import { cn } from '../lib';
import * as React from 'react';
import { useRTL } from '../hooks';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    const isRTL = useRTL();
    const isMinimalistic = useAppSelector(selectIsMinimalistic);

    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-solid border-input bg-transparent px-3 py-1 text-sm leading-[20px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50 md:text-sm',
          isRTL && 'text-right placeholder:text-right',
          isMinimalistic && 'rounded-none shadow-none',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
